const mEditionBillingSalesData = {
  mEditionBillingSalesData: {
    alerts: {
      updatePuntoVentaEstado: {
        activationSuccess: 'El punto de venta fue activado exitosamente.',
        deactivationSuccess: 'El punto de venta fue desactivado exitosamente.',
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.'
      }
    },

    buttonSecondary: {
      createText: 'Crear Punto',
      filterText: 'Filtros'
    },

    quote: {
      firstText: 'Aún no tienes puntos de venta configurados para tus ventas.',
      secondText: 'Aquí puedes crear puntos de venta que luego se mostrarán en los comprobantes de las ventas generadas por tus productos.'
    },

    table: {
      thActive: 'Activo',
      thCurrency: 'Moneda',
      thEdit: 'Editar',
      thInvoice: 'Comprobante',
      thName: 'Nombre'
    },

    tooltip: {
      edit: 'Editar Punto'
    }
  }
}

export default mEditionBillingSalesData
